module.exports = __webpack_public_path__ + "assets/img/tx166_1.aa544073.jpg";